import { mediaItems } from "@/mocks/home";

export default function SectionMedia() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门影片</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">蓝光4K超清 — 全网热播精选</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-200"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[11px] font-medium rounded bg-primary-500 text-white">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-[11px] font-medium bg-black/60 text-white">
                  {item.views}次播放
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center gap-1 mt-1 text-xs text-accent-500">
                  <i className="ri-star-fill text-[10px]"></i>
                  <span>{item.rating}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}